import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

export const getOnboardingBanner = () => {
  return axiosPrivate.get('dashboard/api/v1/onboarding_banner');
};
